<style src="./ReportSyntheticCredit.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="searchWithFilter">
        <div class="formContainer">
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Data Inicial</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  placeholder="30/12/2019"
                  class="form-control"
                  v-model="startDate"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Hora Inicial</label>
              <div class="col-sm-12">
                <input
                  type="time"
                  placeholder="09:00:00"
                  class="form-control"
                  v-model="startTime"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Data final</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  placeholder="30/12/2019"
                  class="form-control"
                  v-model="endDate"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Hora Final</label>
              <div class="col-sm-12">
                <input
                  type="time"
                  placeholder="15:00:00"
                  class="form-control"
                  v-model="endTime"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
          <div class="col-sm-2">
            <button
              class="btn btn-lg btn-primary"
              type="button"
              @click="exportCsv"
            >
              <i class="fa fa-download"></i>
              Exportar CSV
            </button>
          </div>
        </div>
      </form>
    </div>

    <spinner v-if="showSpinner" />

    <div class="ibox-content">
      <div class="alert alert-info col-sm-2">
        Valor Total em Dinheiro:
        <strong>R$ {{ cashTotal | totalToCurrencyBR }}</strong>
      </div>

      <div class="col-sm-1"></div>

      <div class="alert alert-info col-sm-2">
        Valor Total em Débito:
        <strong>R$ {{ debitTotal | totalToCurrencyBR }}</strong>
      </div>

      <div class="col-sm-1"></div>

      <div class="alert alert-info col-sm-2">
        Valor Total em Crédito:
        <strong>R$ {{ creditTotal | totalToCurrencyBR }}</strong>
      </div>

      <div class="col-sm-1"></div>

      <div class="alert alert-info col-sm-2">
        Valor Total em Carteira:
        <strong>R$ {{ walletTotal | totalToCurrencyBR }}</strong>
      </div>
    </div>

    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead>
          <th>Monitor</th>
          <th>Dinheiro</th>
          <th>Débito</th>
          <th>Crédito</th>
          <th>Carteira</th>
          <th>Total</th>
        </thead>
        <tbody>
          <tr class="read" v-for="(item, idx) in resultList" :key="idx">
            <td>{{ item.fullName }}</td>
            <td>{{ item.cashTotal | totalToCurrencyBR }}</td>
            <td>{{ item.debitTotal | totalToCurrencyBR }}</td>
            <td>{{ item.creditTotal | totalToCurrencyBR }}</td>
            <td>{{ item.walletTotal | totalToCurrencyBR }}</td>
            <td>{{ item.total | totalToCurrencyBR }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="btn-group paginatecontent" v-if="countPages > 0">
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageLeft"
        @click="previousPage"
      >
        <i class="fa fa-arrow-left" />
      </button>

      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageRight"
        @click="nextPage"
      >
        <i class="fa fa-arrow-right" />
      </button>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';
import moment from 'moment';

export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      form: {
        pageSkip: 0,
        pageLimit: 30,
      },
      startDate: '2019-10-30',
      endDate: '2019-10-31',
      startTime: '07:00:00',
      endTime: '19:00:00',
      countPages: 0,
      resultList: [],
      walletTotal: 0,
      cashTotal: 0,
      debitTotal: 0,
      creditTotal: 0,
    };
  },
  filters: {
    fillDate(value) {
      return new Date(value).toLocaleDateString('pt-BR');
    },
    fillTime(value) {
      return new Date(value).toLocaleTimeString('pt-BR');
    },
    formatLicencePlate(licencePlate) {
      return licencePlate.toUpperCase();
    },
    totalToCurrencyBR(value) {
      if (!value) {
        return '-';
      }
      // return (value / 100).toFixed(2).toString().replace('.', ',');
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
  },
  computed: {
    hasPageLeft() {
      return this.form.pageSkip === 0;
    },
    hasPageRight() {
      return this.form.pageSkip + this.form.pageLimit >= this.countPages;
    },
  },
  mounted() {
    this.setInitialSateTime();
  },
  methods: {
    setInitialSateTime() {
      const today = new Date();
      this.startDate = moment(today).format('YYYY-MM-DD');
      this.endDate = moment(today).format('YYYY-MM-DD');
    },
    searchWithFilter() {
      this.pageSkip = 0;
      this.filterReport();
    },
    async exportCsv() {
      this.showSpinner = true;
      const query = {
        ...this.form,
      };

      if (this.startDate) {
        if (!this.startTime) {
          this.startTime = '00:00';
        }
        query.startDate = new Date(`${this.startDate} ${this.startTime}:00`);
      }

      if (this.endDate) {
        if (!this.endTime) {
          this.endTime = '00:00';
        }
        query.endDate = new Date(`${this.endDate} ${this.endTime}:00`);
      }

      try {
        const response = await this.$store.dispatch(
          'REPORTS/DownloadSyntheticCreditCsv',
          {
            query,
          },
        );

        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'RELATORIO DE NOTIFICACOES.csv');
        document.body.appendChild(link);
        link.click();
      } catch (errors) {
        this.resultList = [];
      } finally {
        this.showSpinner = false;
      }
    },
    async filterReport() {
      this.showSpinner = true;
      const query = {};
      this.resultList = [];

      if (this.startDate) {
        if (!this.startTime) {
          this.startTime = '00:00';
        }
        const dt = new Date(`${this.startDate} ${this.startTime}:00`);
        query.startDate = dt;
      }

      if (this.endDate) {
        if (!this.endTime) {
          this.endTime = '00:00';
        }
        const dt = new Date(`${this.endDate} ${this.endTime}:00`);
        query.endDate = dt;
      }

      try {
        const reports = await this.$store.dispatch(
          'REPORTS/ReportSyntheticCredit',
          {
            query,
          },
        );

        this.resultList = reports.mergedResult;
        this.cashTotal = reports.cashTotal;
        this.debitTotal = reports.debitTotal;
        this.creditTotal = reports.creditTotal;
        this.walletTotal = reports.walletTotal;

        this.showSpinner = false;
      } catch (errors) {
        this.resultList = [];
        this.showSpinner = false;
      }
    },
    nextPage() {
      if (this.form.pageSkip + this.form.pageLimit > this.countPages) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip + this.form.pageLimit;

      this.filterReport();
    },
    previousPage() {
      if (this.form.pageSkip === 0) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip - this.form.pageLimit;

      this.filterReport();
    },
  },
};
</script>
